import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { isEqual, isEmpty } from 'lodash'
import { fetchOrders, editOrder, updateBalance } from '../../actions/orderActions'
import {
  fetchPosts,
  changeOrderExecutor,
  changeOrderClient,
  changeOrderDate,
  editPost
} from "../../actions/postActions"
import { fetchTodos } from "../../actions/todoActions"
import { fetchTodolists, fetchDefaultTodolists } from "../../actions/todolistActions"
import { fetchInvcs } from "../../actions/invcActions"
import { addSets, fetchSets } from "../../actions/settings"
import { addInvc, editInvc } from '../../actions/invcActions'
import { editFile, fetchFiles } from '../../actions/fileActions'
import { editLink, fetchLinks } from '../../actions/linkActions'
import Select from 'react-select'
import PRSForm from '../prs/PRSForm'
import InvcForm from '../invc/InvcForm'
import FilesAndLinksForm from './FilesAndLinksForm'
import TodolistsForm from '../todo/TodolistsForm'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'
import axios from 'axios'
import { servAddr } from '../../servAddr'
import DuplicateOrderConfirmation from '../ui/DuplicateOrderConfirmation'

class EditOrderForm extends Form {

  state = {
    errors: {},
    showDuplicateConfirmation: false,
    tab: localStorage.prsTab || 'prs'
  }

  componentWillMount(){
    this.props.fetchOrders();
    this.props.fetchSets('ctype');
    this.props.fetchPosts(this.props.orderId);
    this.props.fetchTodos({order_id: this.props.orderId});
    this.props.fetchTodolists({order_id: this.props.orderId});
    this.props.fetchDefaultTodolists();
    this.props.fetchInvcs(this.props.orderId);
    this.props.fetchFiles(this.props.orderId);
    this.props.fetchLinks(this.props.orderId);
    const orders = this.props.orders;
    if(orders.length){
      this.order = orders.find(el => {return el.order_id === parseInt(this.props.orderId,10)});
      if(this.order){
        this.setState({data: {...this.order}});
      }
    }
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps){
    if(this.props!==nextProps){
      const orders = nextProps.orders;
      if(orders.length){
        this.order = orders.find(el => {return el.order_id === parseInt(this.props.orderId,10)});
        if(this.order){
          this.setState({data: {...this.order}});
        }
      }
    }
  }

  saveOrder = e => {
    e.preventDefault();
    this.setState({errors: {}});
    if(this.orderChanged()){
      this.props.editOrder(this.state.data, errors => {
        if (errors) {
          this.setState({errors});
          return;
        }
        if(this.order.order_comp1_id !== this.state.data.order_comp1_id){
          this.props.changeOrderExecutor(this.props.orderId,this.order.order_comp1_id,this.state.data.order_comp1_id)
        }
        if(this.order.order_comp_id !== this.state.data.order_comp_id){
          this.props.changeOrderClient(this.props.orderId,this.order.order_comp_id,this.state.data.order_comp_id)
        }
        if(this.order.order_edate !== this.state.data.order_edate){
          this.props.changeOrderDate(this.props.orderId,this.order.order_edate,this.state.data.order_edate)
        }
      });
    }
  }

  duplicateOrder = e => {
    e.preventDefault();
    this.props.editOrder({
      ...this.state.data,
      duplicate_order: 1,
      order_stts_id: this.props.default_order_stts_id,
      order_empl1: this.props.user_id,
      order_empl2: this.props.user_id
    }, (errors, id) => {
      if (errors) {
        this.setState({
          errors,
          showDuplicateConfirmation: false
        });
        return;
      }
      this.context.router.push('/order');
      this.context.router.push('/order/edit?id='+id);
    });
  }

  exportClick = e => {
    e.preventDefault();
    this.setState({errors: {}});
    const { order_id, order_comp_id } = this.order;
    const { comps } = this.props;
    axios({
      method: 'get',
      url: servAddr + 'excel_prs?order_id=' + order_id,
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `ПРС ${comps[order_comp_id].comp_desc} ${moment().format('Y-MM-DD')}.xls`;
      link.click();
    }, (err) => {
      this.setState({
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  orderChanged = () => {
    return !isEqual(this.order, this.state.data);
  }

  cancelEdit = e => {
    e.preventDefault();
    this.context.router.goBack();
  }

  showSmeta = e => {
    e.preventDefault();
    this.context.router.push('/smeta?order_id='+this.props.orderId);
  }

  showAvans = e => {
    e.preventDefault();
    this.context.router.push('/avans?order_id='+this.props.orderId);
  }

  updateStts = e => {
    e.preventDefault();
    this.setState({
      data:{
        ...this.state.data,
        order_stts_id: parseInt(e.target.value,10)
      }
    });
  }

  updateBalance = (difS, difB1, difB2) => {
    if(parseInt(difS,10) !==0 || parseInt(difB1,10) !==0 || parseInt(difB2,10) !==0){
      this.props.updateBalance(this.state.data.order_id, difS, difB1, difB2);
    }
  }

  changeTab = (e, tab) => {
    e.preventDefault();
    this.setState({tab});
    localStorage.prsTab = tab;
  }

  showDuplicateConfirmation = e => {
    this.setState({showDuplicateConfirmation: true});
  }

  hideDuplicateConfirmation = e => {
    this.setState({showDuplicateConfirmation: false});
  }

  render() {
    if(isEmpty(this.props.sttss)
      || isEmpty(this.props.empls)
      || isEmpty(this.props.comps)
      || isEmpty(this.props.srvcs)
      || isEmpty(this.props.srvgs)
      || isEmpty(this.props.ctypes)
      || isEmpty(this.props.orders)
      || isEmpty(this.props.percs)
      || isEmpty(this.props.places)
      || isEmpty(this.props.etypes)
      || isEmpty(this.props.products)
      || isEmpty(this.props.posts)
      || isEmpty(this.props.requs)
      || isEmpty(this.props.invcs)
      || isEmpty(this.order)
    ){
      return(<div>Не загружены данные</div>);
    }
    if(this.props.comprights.indexOf(this.order.order_comp1_id) === -1){
      return(<div>Нет доступа</div>);
    }
    const {
      requs,
      percs,
      sttss,
      empls,
      comps,
      srvcs,
      srvgs,
      ctypes,
      files,
      filetypes,
      links,
      addSets,
      editPost,
      places,
      etypes,
      products,
      comprights,
      addInvc,
      editInvc,
      editFile,
      editLink
    } = this.props;
    const posts = this.props.posts.hasOwnProperty(this.order.order_id) ?
      this.props.posts[this.order.order_id] :
      [];
    if(!this.state.data.order_id){
      return (
        <div>Заказ не найден</div>
      );
    }

    const { data: order, tab, errors } = this.state;

    var mappedStts = [];
    var sttsColor = '';
    for (var key in sttss){
      if(sttss.hasOwnProperty(key) && sttss[key].stts_active) {
        sttsColor = order.order_stts_id === parseInt(key,10) ? sttss[key].stts_color_id : 'white'
        mappedStts.push(
          <button
            className="btn"
            style={{backgroundColor:sttsColor}}
            key={key}
            value={key}
            onClick={this.updateStts}
          >
            {sttss[key].stts_desc}
          </button>
        );
      }
    }

    var compsOpt = [];
    var comps1Opt = [];
    for (key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active) {
        if((comps[key].comp_own && comprights.indexOf(parseInt(key,10))!==-1)
          || comps[key].comp_id === order.order_comp1_id){
          comps1Opt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
        if(comps[key].comp_order || comps[key].comp_id === order.order_comp_id){
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);
    comps1Opt.sort(sortOpts);
    var empls1Opt = [];
    var empls2Opt = [];
    for (key in empls){
      if(empls.hasOwnProperty(key)) {
        if(empls[key].user_active || empls[key].user_id === order.order_empl1){
          empls1Opt.push({
            value: empls[key].user_id,
            label: empls[key].user_fname + " " + empls[key].user_lname
          });
        }
        if(empls[key].user_active || empls[key].user_id === order.order_empl2){
          empls2Opt.push({
            value: empls[key].user_id,
            label: empls[key].user_fname + " " + empls[key].user_lname
          });
        }
      }
    }
    empls1Opt.sort(sortOpts);
    empls2Opt.sort(sortOpts);
    var placesOpt = [];
    for (key in places){
      if(places.hasOwnProperty(key) &&
        (places[key].place_active || places[key].place_id === order.order_place_id)
      ) {
        placesOpt.push({value:places[key].place_id,label:places[key].place_desc});
      }
    }
    placesOpt.sort(sortOpts);
    var percsOpt = [];
    for (key in percs){
      if(percs.hasOwnProperty(key) &&
        (
          percs[key].perc_active ||
          percs[key].perc_id === order.order_perc_id ||
          percs[key].perc_id === order.order_taxperc_id
        )
      ) {
        percsOpt.push({value:percs[key].perc_id,label:percs[key].perc_desc});
      }
    }
    percsOpt.sort(sortOpts);
    var etypesOpt = [];
    for (key in etypes){
      if(etypes.hasOwnProperty(key) &&
        (etypes[key].etype_active || etypes[key].etype_id === order.order_etype_id)
      ) {
        etypesOpt.push({value:etypes[key].etype_id,label:etypes[key].etype_desc});
      }
    }
    etypesOpt.sort(sortOpts);
    var productsOpt = [];
    for (key in products){
      if(products.hasOwnProperty(key) &&
        (products[key].product_active || products[key].product_id === order.order_product_id)
      ) {
        productsOpt.push({value:products[key].product_id,label:products[key].product_desc});
      }
    }
    productsOpt.sort(sortOpts);

    const saveButton = this.orderChanged() ? <button
        type="button"
        className="btn btn-warning"
        onClick={this.saveOrder}>
        Сохранить
      </button> :
      '';

    return (
      <div>
        <div className="form-group">
          <div className="pull-right">{mappedStts}</div>
          <button type="button" className="btn btn-default"
            onClick={this.cancelEdit}>
            Назад
          </button>{" "}
          <button type="button" className="btn btn-default"
            onClick={this.showSmeta}>
            Смета
          </button>{" "}
          <button type="button" className="btn btn-default"
            onClick={this.showAvans}>
            Авансовый
          </button>{" "}
          <button
            type="button"
            className="btn btn-default dropdown-hover"
          >
            ...
            <ul className="dropdown-menu">
              <li>
                <a
                  href="#"
                  onClick={this.exportClick}
                >
                  Экспорт в Excel
                </a>
              </li>
              <li>
                <a
                  href="#"
                  onClick={this.showDuplicateConfirmation}
                >
                  Дублировать заказ
                </a>
              </li>
            </ul>
          </button>{" "}
          {saveButton}
        </div>
        {this.state.showDuplicateConfirmation && (
          <DuplicateOrderConfirmation
            onConfirm={this.duplicateOrder}
            onCancel={this.hideDuplicateConfirmation}
          />
        )}
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        <div className="pull-right">Создан {moment(order.order_date).format('L')}</div>
        <h2>Заказ №{order.order_num}</h2>
        <div className="row" style={{position: 'relative', zIndex: 2}}>
          <div className="col-sm-6">
            <div className="form-horizontal">
              <div className="form-group">
                <label className="control-label col-sm-4">Дата проведения</label>
                <div className="col-sm-8">
                  <DatePicker
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={moment(order.order_edate)}
                    onChange={e => this.updateDate(e, 'order_edate')}
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Организатор</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={comps1Opt}
                  value={order.order_comp1_id}
                  onChange={e => this.updateSelect(e,'order_comp1_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Заказчик</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={compsOpt}
                  value={order.order_comp_id}
                  onChange={e => this.updateSelect(e,'order_comp_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Контракт</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={order.order_contract}
                    name="order_contract"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Название</label>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    value={order.order_desc}
                    name="order_desc"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className="control-label col-sm-4">Аккаунт менеджер</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={empls1Opt}
                  value={order.order_empl1}
                  onChange={e => this.updateSelect(e,'order_empl1')}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-horizontal">
              <div className="form-group">
                <label className="control-label col-sm-4">Направление</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={etypesOpt}
                  value={order.order_etype_id}
                  onChange={e => this.updateSelect(e,'order_etype_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Продукт</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={productsOpt}
                  value={order.order_product_id}
                  onChange={e => this.updateSelect(e,'order_product_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Площадка</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={placesOpt}
                  value={order.order_place_id}
                  onChange={e => this.updateSelect(e,'order_place_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Надбавка / Налог</label>
                <Select
                  className="col-sm-4"
                  clearable={false}
                  options={percsOpt}
                  value={order.order_perc_id}
                  onChange={e => this.updateSelect(e,'order_perc_id')}
                />
                <Select
                  className="col-sm-4"
                  clearable={false}
                  options={percsOpt}
                  value={order.order_taxperc_id}
                  onChange={e => this.updateSelect(e,'order_taxperc_id')}
                />
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Заметка</label>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    value={order.order_note}
                    name="order_note"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className="control-label col-sm-4">Проджект менеджер</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={empls2Opt}
                  value={order.order_empl2}
                  onChange={e => this.updateSelect(e,'order_empl2')}
                />
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs order-tabs">
          <li className={tab==='prs'?"active":''}>
            <a onClick={e => this.changeTab(e,'prs')} href="#">ПРС</a>
          </li>
          <li className={tab==='cost'?"active":''}>
            <a onClick={e => this.changeTab(e,'cost')} href="#">С ПОДРЯДОМ</a>
          </li>
          <li className={tab==='pmnt'?"active":''}>
            <a onClick={e => this.changeTab(e,'pmnt')} href="#">С ОПЛАТАМИ</a>
          </li>
          <li className={tab==='invc'?"active":''}>
            <a onClick={e => this.changeTab(e,'invc')} href="#">СЧЕТА И АКТЫ</a>
          </li>
          <li className={tab==='checklist'?"active":''}>
            <a onClick={e => this.changeTab(e,'checklist')} href="#">ЧЕК-ЛИСТЫ</a>
          </li>
          <li className={tab==='file'?"active":''}>
            <a onClick={e => this.changeTab(e,'file')} href="#">ФАЙЛЫ</a>
          </li>
        </ul>
        {tab === 'prs' || tab === 'cost' || tab === 'pmnt' ?
          <PRSForm
            tab={tab}
            order={this.order}
            posts={posts}
            comps={comps}
            srvcs={srvcs}
            srvgs={srvgs}
            ctypes={ctypes}
            addSets={addSets}
            editPost={editPost}
            percs={percs}
            updtBlnc={this.updateBalance}
          />
          :[]
        }
        {tab === 'invc' ?
          <InvcForm
            order={this.order}
            invcs={this.props.invcs[this.order.order_id]}
            requs={requs}
            addInvc={addInvc}
            editInvc={editInvc}
          />
          :[]
        }
        {tab === 'checklist' ?
          <TodolistsForm
            order={this.order}
          />
          :[]
        }
        {tab === 'file' ?
          <FilesAndLinksForm
            order={this.order}
            files={files[this.order.order_id] || []}
            filetypes={filetypes}
            editFile={editFile}
            links={links[this.order.order_id] || []}
            editLink={editLink}
          />
          :[]
        }
      </div>
    );
  }
}

EditOrderForm.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    orders: store.orders.data,
    comps: store.comps.data,
    percs: store.percs.data,
    etypes: store.etypes.data,
    products: store.products.data,
    places: store.places.data,
    sttss: store.sttss.data,
    empls: store.empls,
    posts: store.posts,
    comprights: store.auth.comprights,
    user_id: store.auth.user.user_id,
    invcs: store.invcs,
    files: store.files,
    filetypes: store.filetypes.data,
    links: store.links,
    requs: store.requs.data,
    srvcs: store.srvcs.data,
    srvgs: store.srvgs.data,
    ctypes: store.ctypes.data,
    default_order_stts_id: store.settings.default_order_stts_id
  }
}

export default connect(mapOrdersToProps, {
  fetchPosts,
  fetchOrders,
  editOrder,
  updateBalance,
  changeOrderExecutor,
  changeOrderClient,
  changeOrderDate,
  fetchInvcs,
  editPost,
  fetchTodos,
  fetchTodolists,
  fetchDefaultTodolists,
  addSets,
  fetchSets,
  addInvc,
  editInvc,
  editFile,
  fetchFiles,
  editLink,
  fetchLinks
})(EditOrderForm);



// WEBPACK FOOTER //
// ./src/components/order/EditOrderForm.js